import React, { useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';

const convertISOToReadableTimeFormat = (date) => {
  return format(parseISO(date), "MM/dd/yy");
};

const tableHeading = [
  { label: 'Date', field: 'Date' },
  { label: 'Action', field: 'Action' },
  { label: 'Committee', field: 'Committee' },
  { label: 'Yes Votes', field: 'Votes (Yes)' },
  { label: 'No Votes', field: 'Votes (No)' }
];

const Status = ({ bill, onLoad}) => {
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    const formatRowStructureForStatusTable = (billActions) => {
      return billActions.map((item) => ({
        Date: convertISOToReadableTimeFormat(item?.date),
        Action: item?.actionType?.description || '',
        Committee: item?.committee?.committeeName || '',
        'Votes (Yes)': item?.yesVotes || '',
        'Votes (No)': item?.noVotes || '',
      }));
    };
    const formattedRow = formatRowStructureForStatusTable(bill.billActions);
    setFormattedData(formattedRow);
    onLoad();
  }, [bill]);

  return (
    <div>
      <table className="table table-bordered">
        <thead>
          <tr>
            {tableHeading.map((heading) => (
              <th key={heading.field}>{heading.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {formattedData.length > 0 ? (
            formattedData.map((row, index) => (
              <tr key={index}>
                <td>{row.Date}</td>
                <td>{row.Action}</td>
                <td>{row.Committee}</td>
                <td>{row['Votes (Yes)']}</td>
                <td>{row['Votes (No)']}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={tableHeading.length} className="text-center">
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="dataTables_info" role="status" aria-live="polite">
        <small>
          Showing 1 to {formattedData.length} of {formattedData.length} entries
        </small>
      </div>
    </div>
  );
};

export default Status;
